import React from 'react';
import styled from 'astroturf/react';
import _CountBubble from "DoubleDigitCountBubble-CountBubble.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/DoubleDigitCountBubble.tsx?styleId=CountBubble";


export const CountBubble = /*#__PURE__*/styled("div", null, {
  displayName: "CountBubble",
  styles: _CountBubble
});

const DoubleDigitCountBubble = ({
  count,
  className,
}: {
  count: number | null;
  className?: string;
}) => {
  if (!count || count === 0) return null;

  const displayCount = count < 100 ? count : '99+';
  return <CountBubble className={className}>{displayCount}</CountBubble>;
};

export default DoubleDigitCountBubble;
